// extracted by mini-css-extract-plugin
module.exports =  {"icon":"icon--Gcyvb","svg":"svg--Mdor1"};